module.exports = __webpack_public_path__ + "static/media/Loupe.2f9abfc2.svg";